// Cart page helper. The old delivery-time dropdown that replaced the cart note now lives in
// snippets/db-cart-delivery.liquid (Oct 2026); this file only hides the checkout form in the add-to-cart pop-up.
document.addEventListener('DOMContentLoaded', function () {
  var cartNotificationForm = document.getElementById('cart-notification-form');
  if (cartNotificationForm) cartNotificationForm.style.display = 'none';
});
